module.exports = __webpack_public_path__ + "img/half_cut_cell_triple.79a99a1c.png";